import { createRouter, createWebHistory } from 'vue-router';
import homeVue from './components/home.vue'
import lawVue from './components/lawVue.vue'
const routes = [
    {
        path: '/',
        redirect: '/cvi/home'
    },
    {
        path: '/cvi/home',
        name: 'homeVue',
        component: homeVue
    },
    {
        path: '/cvi/legalnotice',
        name: 'lawVue',
        component: lawVue
    }
];



const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

router.beforeEach(async (to, from, next) => {
    next()
})



export default router
